function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.941176%,12.941176%,12.941176%)",
      fillOpacity: 1
    },
    d: "M 5.988281 3.125 L 19.011719 3.125 C 20.59375 3.125 21.875 4.40625 21.875 5.988281 L 21.875 19.011719 C 21.875 20.59375 20.59375 21.875 19.011719 21.875 L 5.988281 21.875 C 4.40625 21.875 3.125 20.59375 3.125 19.011719 L 3.125 5.988281 C 3.125 4.40625 4.40625 3.125 5.988281 3.125 Z M 5.988281 4.6875 C 5.269531 4.6875 4.6875 5.269531 4.6875 5.988281 L 4.6875 19.011719 C 4.6875 19.730469 5.269531 20.3125 5.988281 20.3125 L 19.011719 20.3125 C 19.730469 20.3125 20.3125 19.730469 20.3125 19.011719 L 20.3125 5.988281 C 20.3125 5.269531 19.730469 4.6875 19.011719 4.6875 Z M 5.988281 4.6875 "
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUnchecked);
export default __webpack_public_path__ + "static/media/checkbox-unchecked.a911842c6669917c02b50dcb8d31a703.svg";
export { ForwardRef as ReactComponent };